declare namespace $ {

	type $mol_link__arg_shm_dashboard_admin_book_1 = $mol_type_enforce<
		({ 
			'admin_section': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_dashboard_admin_book_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__current_shm_dashboard_admin_book_3 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['users_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__arg_shm_dashboard_admin_book_4 = $mol_type_enforce<
		({ 
			'admin_section': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_dashboard_admin_book_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__current_shm_dashboard_admin_book_6 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_book['wordstat_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_view__sub_shm_dashboard_admin_book_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_shm_dashboard_admin_book_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_dashboard_admin_book_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	export class $shm_dashboard_admin_book extends $mol_book2 {
		admin_pages( ): readonly(any)[]
		users_current( ): boolean
		Users_link( ): $mol_link
		wordstat_current( ): boolean
		Wordstat_link( ): $mol_link
		Navigation( ): $mol_view
		section( next?: string ): string
		placeholders( ): readonly(any)[]
		pages( ): ReturnType< $shm_dashboard_admin_book['admin_pages'] >
		Menu( ): $mol_page
		Users( ): $shm_dashboard_admin_users
		Wordstat( ): $shm_dashboard_admin_wordstat
	}
	
}

//# sourceMappingURL=book.view.tree.d.ts.map